import { Range, Transforms } from "slate";
import { isBlockActive } from "./isBlockActive";
import { unwrapLink } from "./unwrapLink";
export var wrapLink = function (editor, url) {
    if (isBlockActive(editor, "link")) {
        unwrapLink(editor);
    }
    var selection = editor.selection;
    var isCollapsed = selection && Range.isCollapsed(selection);
    var link = {
        type: "link",
        url: url,
        children: isCollapsed ? [{ text: url }] : [],
    };
    if (isCollapsed) {
        Transforms.insertNodes(editor, link);
    }
    else {
        Transforms.wrapNodes(editor, link, { split: true });
        Transforms.collapse(editor, { edge: "end" });
    }
};
